// utils/fieldsOptions.js 

export const getFieldOptions = () => {
  return [
    "Accounting",
    "Actuarial Science",
    "Agricultural Science",
    "Architecture",
    "Biochemistry",
    "Biology",
    "Business Administration",
    "Chemistry",
    "Civil Engineering",
    "Computer Science",
    "Data Science",
    "Economics",
    "Electrical Engineering",
    "Finance",
    "Geography",
    "Health Science",
    "Human Resource Management",
    "Information Technology",
    "Administration",
    "Law",
    "Marketing",
    "Mathematics",
    "Mechanical Engineering",
    "Medicine",
    "Nursing",
    "Pharmacy",
    "Physics",
    "Political Science",
    "Psychology",
    "Public Health",
    "Statistics",
    "Software Engineering",
    "Other",
  ];
};